@let formGroupApp = userService.formGroupApp;
@let productListValue = productList();
@let egpTypesValue = egpTypes();
@let areAllProductsSelectedValue = userService.areAllProductsSelected();
@let userServiceUserDataValue = userService.userData();
<form [formGroup]="formGroupApp">
  @if (formGroupApp | isNil: false) {
    <mat-card appearance="outlined">
      <div class="form-column-left">
        <fa-icon
          [icon]="['far', 'mobile']"
          size="4x"
          style="color: grey"></fa-icon>
      </div>
      <div class="form-column-right">
        <p>
          <fa-icon [icon]="['far', 'exclamation-triangle']"></fa-icon>
          {{ 'PRODUCT.USERADMIN.APP.LICENCEHINT' | translate }}
        </p>
        <table>
          <tr>
            <td>
              <mat-checkbox
                formControlName="active"
                #appAccess
                (change)="
                  onClickSectionCheckbox({ section: 'app', event: $event })
                ">
                Nutzer für
                <b>MeteoFocus App</b> freischalten. </mat-checkbox
              >&nbsp;
            </td>
            @let userServiceUsedContingentsValue =
              userService.usedContingents();
            @let contingentsValue = contingents();
            <td>
              <fa-icon
                [icon]="['far', 'asterisk']"
                [ngStyle]="{
                  color:
                    userServiceUsedContingentsValue['app'] <
                    contingentsValue['app']
                      ? 'green'
                      : 'red',
                }"></fa-icon
              >&nbsp;
            </td>
            <td>
              <table class="upload-format-table">
                <tr>
                  <td>
                    {{ 'PRODUCT.USERADMIN.CONTINGENT.TEXT1' | translate }}
                    {{ 'PRODUCT.USERADMIN.CONTINGENT.app' | translate }}
                    :
                  </td>
                  <td>{{ contingentsValue['app'] }}</td>
                </tr>
                <tr>
                  <td>
                    {{ 'PRODUCT.USERADMIN.CONTINGENT.TEXT2' | translate }}:
                  </td>
                  <td>{{ userServiceUsedContingentsValue['app'] }}</td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
        <br />
        @if (appAccess.checked) {
          <mat-form-field>
            <mat-label>Laufzeit von</mat-label>
            <input
              matInput
              [matDatepicker]="picker6"
              formControlName="dateFrom" />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker6"></mat-datepicker-toggle>
            <mat-datepicker #picker6></mat-datepicker>
          </mat-form-field>
          &nbsp;
          <mat-checkbox formControlName="endless" #appEndless
            >Unbegrenzte Laufzeit</mat-checkbox
          >
          @if (!appEndless.checked) {
            <br />
            <mat-form-field>
              <input
                matInput
                [matDatepicker]="picker7"
                formControlName="dateTo" />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker7"></mat-datepicker-toggle>
              <mat-datepicker #picker7></mat-datepicker>
            </mat-form-field>
            &nbsp;

            @if (dateToFormControlErrors() | isNil: false) {
              <div class="error-text">
                {{ 'PRODUCT.USERADMIN.STAMMDATEN.DATEERROR' | translate }}
              </div>
            }
          }
        }
      </div>
      <div class="clear"></div>
    </mat-card>
  }
  <br />
  @if (formGroupApp | isNil: false) {
    @if (activeFormControlValue()) {
      <!--Product Card (Einsatzwetter App)-->
      <mat-card appearance="outlined">
        <p>
          <b>{{ 'PRODUCT.USERADMIN.PRODUCTS.TITLE' | translate }}</b>
        </p>
        <mat-checkbox
          #allProductsApp
          [checked]="areAllProductsSelectedValue.app"
          (change)="onClickAllProducts({ section: 'app', event: $event })"
          >Benutzer darf alle bestellten Produkte sehen (Standard)
        </mat-checkbox>
        <br />
        @if (!allProductsApp.checked) {
          <ng-container
            *ngTemplateOutlet="
              buttonsTemplate();
              context: { section: 'app' }
            "></ng-container>

          <mat-list>
            @if (productListValue.epp | isNotEmptyObject) {
              <!--epp-->
              <div mat-subheader>
                <fa-icon [icon]="['far', 'clouds-sun']" size="lg"></fa-icon>
                &nbsp; {{ 'PRODUCT.EPP.TITLE' | translate }} NEU
              </div>

              <mat-accordion
                #accordionEppApp="matAccordion"
                multi
                class="accordion-headers-align">
                @let eppProductsInListValue =
                  productListValue | eppProductsInList;
                <mat-expansion-panel
                  (expandedChange)="onExpandedChanged('app')">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      @let hasUserEppProduct =
                        'app'
                          | hasUserEppProduct
                            : areAllProductsSelectedValue
                            : userServiceUserDataValue
                            : productListValue;
                      @if (hasUserEppProduct) {
                        <span>
                          <fa-icon
                            [icon]="['far', 'check']"
                            style="color: green"></fa-icon>
                        </span>
                      } @else {
                        <span>
                          <fa-icon
                            [icon]="['far', 'times']"
                            style="color: red"></fa-icon>
                        </span>
                      }
                      &nbsp; EPP
                      <!--
                            &nbsp;{{ 'PRODUCT.EPP.PARAMETERSET.SETS.' + parameterset | translate }} -
                            {{ resolution.days }} {{ 'PRODUCT.EPP.RESOLUTION.DAYS' | translate }}
                            ({{ 'PRODUCT.EPP.RESOLUTION.HOURLY.' + resolution.hourly | translate }})
                            -->
                    </mat-panel-title>
                    <mat-panel-description>
                      {{
                        'app'
                          | countUserProductStations
                            : areAllProductsSelectedValue
                            : 'epp'
                            : {
                                epp: true,
                              }
                            : productListValue
                            : userServiceUserDataValue
                      }}
                      / {{ eppProductsInListValue.length }}
                      {{ 'PRODUCT.USERADMIN.PLACES' | translate }}
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <table class="product-detail-table" width="100%">
                    <tr>
                      <th>{{ 'PRODUCT.USERADMIN.PLACE' | translate }}</th>
                      <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                      <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                    </tr>
                    @for (
                      product of eppProductsInListValue;
                      track $index;
                      let i = $index
                    ) {
                      <tr>
                        <td align="center">
                          <mat-checkbox
                            #check
                            [checked]="
                              userServiceUserDataValue
                                | hasUserStation
                                  : product
                                  : 'app'
                                  : areAllProductsSelectedValue
                            "
                            (change)="
                              onUserStationChange({
                                event: $event,
                                product,
                                section: 'app',
                              })
                            "></mat-checkbox>
                        </td>
                        <td>
                          {{ product['station']['overwriteStationName'] }}
                        </td>
                        <td>
                          @if (product['outOfSeason']) {
                            <fa-icon
                              [icon]="['far', 'times']"
                              style="color: red"></fa-icon>
                          } @else {
                            <fa-icon
                              [icon]="['far', 'check']"
                              style="color: green"></fa-icon>
                          }
                        </td>
                        <td>
                          {{ product['productData']['saison']['start']['day'] }}
                          .{{
                            product['productData']['saison']['start']['month']
                          }}. -
                          {{ product['productData']['saison']['end']['day'] }}
                          .{{
                            product['productData']['saison']['end']['month']
                          }}.
                        </td>
                      </tr>
                    }
                  </table>
                </mat-expansion-panel>
              </mat-accordion>
            }

            @if (productListValue.eop | isNotEmptyObject) {
              <!--EOP Product Accordion-->
              <div mat-subheader>
                <fa-icon [icon]="['far', 'table']" size="lg"></fa-icon>
                &nbsp; {{ 'PRODUCT.EOP.TITLE' | translate }}
              </div>
              <mat-accordion
                #accordionEopApp="matAccordion"
                multi
                class="accordion-headers-align">
                @for (eopType of eopTypes(); track $index) {
                  @if (productListValue.eop.hasOwnProperty(eopType)) {
                    <mat-expansion-panel
                      (expandedChange)="onExpandedChanged('app')">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          @let hasUserEopProduct =
                            'app'
                              | hasUserEopProduct
                                : areAllProductsSelectedValue
                                : userServiceUserDataValue
                                : productListValue
                                : eopType;
                          @if (hasUserEopProduct) {
                            <span>
                              <fa-icon
                                [icon]="['far', 'check']"
                                style="color: green"></fa-icon>
                            </span>
                          } @else {
                            <span>
                              <fa-icon
                                [icon]="['far', 'times']"
                                style="color: red"></fa-icon>
                            </span>
                          }
                          &nbsp;{{ 'PRODUCT.EOP.TYPE.' + eopType | translate }}
                        </mat-panel-title>
                        <mat-panel-description>
                          {{
                            'app'
                              | countUserProductStations
                                : areAllProductsSelectedValue
                                : 'eop'
                                : {
                                    productType: eopType,
                                  }
                                : productListValue
                                : userServiceUserDataValue
                          }}
                          / {{ productListValue.eop[eopType].length }}
                          {{ 'PRODUCT.USERADMIN.PLACES' | translate }}
                        </mat-panel-description>
                      </mat-expansion-panel-header>

                      <table class="product-detail-table" width="100%">
                        <tr>
                          <th align="center">
                            {{ 'PRODUCT.USERADMIN.USERHASACCESS' | translate }}
                          </th>
                          <th>{{ 'PRODUCT.USERADMIN.PLACE' | translate }}</th>
                          <th>
                            {{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}
                          </th>
                          <th>
                            {{ 'PRODUCT.USERADMIN.SEASON' | translate }}
                          </th>
                        </tr>
                        @for (
                          product of productListValue.eop[eopType];
                          track $index;
                          let i = $index
                        ) {
                          <tr>
                            <td align="center">
                              <mat-checkbox
                                [checked]="
                                  userServiceUserDataValue
                                    | hasUserStation
                                      : product
                                      : 'app'
                                      : areAllProductsSelectedValue
                                "
                                (change)="
                                  onUserStationChange({
                                    event: $event,
                                    product,
                                    section: 'app',
                                  })
                                "></mat-checkbox>
                            </td>
                            <td>
                              {{ product['station']['overwriteStationName'] }}
                            </td>
                            <td>
                              @if (product['outOfSeason']) {
                                <fa-icon
                                  [icon]="['far', 'times']"
                                  style="color: red"></fa-icon>
                              } @else {
                                <fa-icon
                                  [icon]="['far', 'check']"
                                  style="color: green"></fa-icon>
                              }
                            </td>
                            <td>
                              {{
                                product['productData']['saison']['start']['day']
                              }}
                              .{{
                                product['productData']['saison']['start'][
                                  'month'
                                ]
                              }}. -
                              {{
                                product['productData']['saison']['end']['day']
                              }}
                              .{{
                                product['productData']['saison']['end'][
                                  'month'
                                ]
                              }}.
                            </td>
                          </tr>
                        }
                      </table>
                    </mat-expansion-panel>
                  }
                }
              </mat-accordion>
            }
            @if (
              productListValue.egp.length + productListValue.egpsummer.length >
              0
            ) {
              <!--EGP Product Accordion-->
              <div mat-subheader>
                <fa-icon [icon]="['far', 'pen']" size="lg"></fa-icon>
                &nbsp; {{ 'PRODUCT.EGP.TITLE' | translate }}
              </div>
            }

            <mat-accordion
              #accordionEgpApp="matAccordion"
              multi
              class="accordion-headers-align">
              @for (productType of ['egp', 'egpsummer']; track $index) {
                @if (productListValue[productType].length > 0) {
                  <mat-expansion-panel
                    (expandedChange)="onExpandedChanged('app')">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        @if (
                          'app'
                            | hasUserProductType
                              : productType
                              : productListValue
                              : areAllProductsSelectedValue
                              : userServiceUserDataValue
                        ) {
                          <span>
                            <fa-icon
                              [icon]="['far', 'check']"
                              style="color: green"></fa-icon>
                          </span>
                        } @else {
                          <span>
                            <fa-icon
                              [icon]="['far', 'times']"
                              style="color: red"></fa-icon>
                          </span>
                        }
                        &nbsp;{{
                          'SAISON.' + egpTypesValue[productType] | translate
                        }}
                      </mat-panel-title>
                      <mat-panel-description>
                        {{
                          'app'
                            | countUserProducts
                              : productType
                              : productListValue
                              : areAllProductsSelectedValue
                              : userServiceUserDataValue
                        }}
                        /
                        {{ productListValue[productType].length }}
                        {{ 'PRODUCT.USERADMIN.REGIONS' | translate }}
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <table class="product-detail-table" width="100%">
                      <tr>
                        <th align="center">
                          {{ 'PRODUCT.USERADMIN.USERHASACCESS' | translate }}
                        </th>
                        <th>{{ 'PRODUCT.USERADMIN.REGION' | translate }}</th>
                        <th>
                          {{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}
                        </th>
                        <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                      </tr>
                      @for (
                        product of productListValue[productType];
                        track $index;
                        let i = $index
                      ) {
                        <tr>
                          <td align="center">
                            <mat-checkbox
                              [checked]="
                                'app'
                                  | hasUserProduct
                                    : areAllProductsSelectedValue
                                    : userServiceUserDataValue
                                    : product['id']
                              "
                              (change)="
                                onUserProductChange({
                                  event: $event,
                                  product,
                                  section: 'app',
                                })
                              "></mat-checkbox>
                          </td>
                          <td>{{ product['area'] }}</td>
                          <td>
                            @if (product['outOfSeason']) {
                              <fa-icon
                                [icon]="['far', 'times']"
                                style="color: red"></fa-icon>
                            } @else {
                              <fa-icon
                                [icon]="['far', 'check']"
                                style="color: green"></fa-icon>
                            }
                          </td>
                          <td>
                            {{
                              product['productData']['saison']['start']['day']
                            }}
                            .{{
                              product['productData']['saison']['start'][
                                'month'
                              ]
                            }}. -
                            {{ product['productData']['saison']['end']['day'] }}
                            .{{
                              product['productData']['saison']['end']['month']
                            }}.
                          </td>
                        </tr>
                      }
                    </table>
                  </mat-expansion-panel>
                }
              }
            </mat-accordion>
            @if (
              productListValue.egw.length + productListValue.egwsummer.length >
              0
            ) {
              <!--EGW Product Accordion-->
              <div mat-subheader>
                <fa-icon
                  [icon]="['far', 'exclamation-triangle']"
                  size="lg"></fa-icon>
                &nbsp; {{ 'PRODUCT.WARNING.TITLE' | translate }}
              </div>
            }
            <mat-accordion
              #accordionEgwApp="matAccordion"
              multi
              class="accordion-headers-align">
              @for (productType of ['egw']; track $index) {
                @if (productListValue[productType].length > 0) {
                  <mat-expansion-panel
                    (expandedChange)="onExpandedChanged('app')">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        @if (
                          'app'
                            | hasUserProductType
                              : productType
                              : productListValue
                              : areAllProductsSelectedValue
                              : userServiceUserDataValue
                        ) {
                          <span>
                            <fa-icon
                              [icon]="['far', 'check']"
                              style="color: green"></fa-icon>
                          </span>
                        } @else {
                          <span>
                            <fa-icon
                              [icon]="['far', 'times']"
                              style="color: red"></fa-icon>
                          </span>
                        }
                        &nbsp;
                        {{ 'SAISON.' + egpTypesValue[productType] | translate }}
                      </mat-panel-title>
                      <mat-panel-description>
                        {{
                          'app'
                            | countUserProducts
                              : 'egw'
                              : productListValue
                              : areAllProductsSelectedValue
                              : userServiceUserDataValue
                        }}
                        /
                        {{ productListValue.egw.length }}
                        {{ 'PRODUCT.USERADMIN.REGIONS' | translate }}
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <table class="product-detail-table" width="100%">
                      <tr>
                        <th align="center">
                          {{ 'PRODUCT.USERADMIN.USERHASACCESS' | translate }}
                        </th>
                        <th>{{ 'PRODUCT.USERADMIN.REGION' | translate }}</th>
                        <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                        <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                      </tr>
                      @for (
                        product of productListValue.egw;
                        track $index;
                        let i = $index
                      ) {
                        <tr>
                          <td align="center">
                            <mat-checkbox
                              [checked]="
                                'app'
                                  | hasUserProduct
                                    : areAllProductsSelectedValue
                                    : userServiceUserDataValue
                                    : product['id']
                              "
                              (change)="
                                onUserProductChange({
                                  event: $event,
                                  product,
                                  section: 'app',
                                })
                              "></mat-checkbox>
                          </td>
                          <td>{{ product['area'] }}</td>
                          <td>
                            @if (product['outOfSeason']) {
                              <fa-icon
                                [icon]="['far', 'times']"
                                style="color: red"></fa-icon>
                            } @else {
                              <fa-icon
                                [icon]="['far', 'check']"
                                style="color: green"></fa-icon>
                            }
                          </td>
                          <td>
                            {{
                              product['productData']['saison']['start']['day']
                            }}
                            .{{
                              product['productData']['saison']['start'][
                                'month'
                              ]
                            }}. -
                            {{ product['productData']['saison']['end']['day'] }}
                            .{{
                              product['productData']['saison']['end']['month']
                            }}.
                          </td>
                        </tr>
                      }
                    </table>
                  </mat-expansion-panel>
                }
              }

              @for (productType of ['egwsummer']; track $index) {
                @if (productListValue[productType].length > 0) {
                  <mat-expansion-panel
                    (expandedChange)="onExpandedChanged('app')">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        @if (
                          'app'
                            | hasUserProductType
                              : productType
                              : productListValue
                              : areAllProductsSelectedValue
                              : userServiceUserDataValue
                        ) {
                          <span>
                            <fa-icon
                              [icon]="['far', 'check']"
                              style="color: green"></fa-icon>
                          </span>
                        } @else {
                          <span>
                            <fa-icon
                              [icon]="['far', 'times']"
                              style="color: red"></fa-icon>
                          </span>
                        }
                        &nbsp;
                        {{ 'SAISON.' + egpTypesValue[productType] | translate }}
                      </mat-panel-title>
                      <mat-panel-description>
                        {{
                          'app'
                            | countUserProducts
                              : 'egwsummer'
                              : productListValue
                              : areAllProductsSelectedValue
                              : userServiceUserDataValue
                        }}
                        /
                        {{ productListValue.egwsummer.length }}
                        {{ 'PRODUCT.USERADMIN.WARNPLACES' | translate }}
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <table class="product-detail-table" width="100%">
                      <tr>
                        <th align="center">
                          {{ 'PRODUCT.USERADMIN.USERHASACCESS' | translate }}
                        </th>
                        <th>{{ 'PRODUCT.USERADMIN.WARNPLACE' | translate }}</th>
                        <th>{{ 'PRODUCT.USERADMIN.WARNTYPES' | translate }}</th>
                        <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                        <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                      </tr>
                      @for (
                        product of productListValue.egwsummer;
                        track $index;
                        let i = $index
                      ) {
                        <tr>
                          <td align="center">
                            <mat-checkbox
                              [checked]="
                                'app'
                                  | hasUserProduct
                                    : areAllProductsSelectedValue
                                    : userServiceUserDataValue
                                    : product['id']
                              "
                              (change)="
                                onUserProductChange({
                                  event: $event,
                                  product,
                                  section: 'app',
                                })
                              "></mat-checkbox>
                          </td>
                          <td>{{ product['area'] }}</td>
                          <td>
                            @if (product['productData']['info']) {
                              <span
                                >{{
                                  'PRODUCT.WARNING.TYPE.VORAB' | translate
                                }}
                                (E-Mail)<br
                              /></span>
                            }
                            @if (product['productData']['nowcast']) {
                              <span
                                >{{
                                  'METPARA_MEDIUM.THUNDERSTORM' | translate
                                }}
                                <br
                              /></span>
                            }
                            @if (product['productData']['heavyRainWarning']) {
                              <span
                                >{{ 'METPARA_SHORT.HEAVY_RAIN' | translate }}
                                <br
                              /></span>
                            }
                            @if (
                              product['productData']['precipitationWarning']
                            ) {
                              <span
                                >{{
                                  'PRODUCT.EGP-SUMMER.RISKBOX.DRAIN' | translate
                                }}
                                <br
                              /></span>
                            }
                            @if (product['productData']['windWarning']) {
                              <span
                                >{{
                                  'PRODUCT.EGP-SUMMER.RISKBOX.STORM' | translate
                                }}
                                <br
                              /></span>
                            }
                          </td>
                          <td>
                            @if (product['outOfSeason']) {
                              <fa-icon
                                [icon]="['far', 'times']"
                                style="color: red"></fa-icon>
                            } @else {
                              <fa-icon
                                [icon]="['far', 'check']"
                                style="color: green"></fa-icon>
                            }
                          </td>
                          <td>
                            {{
                              product['productData']['saison']['start']['day']
                            }}
                            .{{
                              product['productData']['saison']['start'][
                                'month'
                              ]
                            }}. -
                            {{ product['productData']['saison']['end']['day'] }}
                            .{{
                              product['productData']['saison']['end']['month']
                            }}.
                          </td>
                        </tr>
                      }
                    </table>
                  </mat-expansion-panel>
                }
              }
            </mat-accordion>
            @if (
              productListValue.smw.gma.length +
                productListValue.smw.synop.length >
              0
            ) {
              <!--SMW Product Accordion-->
              <div mat-subheader>
                <fa-icon [icon]="['far', 'analytics']" size="lg"></fa-icon>
                &nbsp; {{ 'PRODUCT.SMW.TITLE' | translate }}
              </div>
            }
            <mat-accordion
              #accordionSmwApp="matAccordion"
              multi
              class="accordion-headers-align">
              @for (stationType of ['gma', 'synop']; track $index) {
                @if (productListValue.smw[stationType].length > 0) {
                  <mat-expansion-panel
                    (expandedChange)="onExpandedChanged('app')">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        @let hasUserSmwProduct =
                          'app'
                            | hasUserSmwProduct
                              : areAllProductsSelectedValue
                              : userServiceUserDataValue
                              : productListValue
                              : stationType;
                        @if (hasUserSmwProduct) {
                          <span>
                            <fa-icon
                              [icon]="['far', 'check']"
                              style="color: green"></fa-icon>
                          </span>
                        } @else {
                          <span>
                            <fa-icon
                              [icon]="['far', 'times']"
                              style="color: red"></fa-icon>
                          </span>
                        }
                        &nbsp;{{
                          'PRODUCT.SMW.STATION.TYPE.' +
                            (stationType | uppercase) | translate
                        }}
                      </mat-panel-title>
                      <mat-panel-description>
                        {{
                          'app'
                            | countUserProductStations
                              : areAllProductsSelectedValue
                              : 'smw'
                              : {
                                  productType: stationType,
                                }
                              : productListValue
                              : userServiceUserDataValue
                        }}
                        / {{ productListValue.smw[stationType].length }}
                        {{ 'PRODUCT.USERADMIN.STATIONS' | translate }}
                      </mat-panel-description>
                    </mat-expansion-panel-header>

                    <table class="product-detail-table" width="100%">
                      <tr>
                        <th align="center">
                          {{ 'PRODUCT.USERADMIN.USERHASACCESS' | translate }}
                        </th>
                        <th>{{ 'PRODUCT.USERADMIN.STATION' | translate }}</th>
                        <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                        <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                      </tr>
                      @for (
                        product of productListValue.smw[stationType];
                        track $index;
                        let i = $index
                      ) {
                        <tr>
                          <td align="center">
                            <mat-checkbox
                              [checked]="
                                userServiceUserDataValue
                                  | hasUserStation
                                    : product
                                    : 'app'
                                    : areAllProductsSelectedValue
                              "
                              (change)="
                                onUserStationChange({
                                  event: $event,
                                  product,
                                  section: 'app',
                                })
                              "></mat-checkbox>
                          </td>
                          <td>
                            {{ product['station']['overwriteStationName'] }}
                          </td>
                          <td>
                            @if (product['outOfSeason']) {
                              <fa-icon
                                [icon]="['far', 'times']"
                                style="color: red"></fa-icon>
                            } @else {
                              <fa-icon
                                [icon]="['far', 'check']"
                                style="color: green"></fa-icon>
                            }
                          </td>
                          <td>
                            {{
                              product['productData']['saison']['start']['day']
                            }}
                            .{{
                              product['productData']['saison']['start'][
                                'month'
                              ]
                            }}. -
                            {{ product['productData']['saison']['end']['day'] }}
                            .{{
                              product['productData']['saison']['end']['month']
                            }}.
                          </td>
                        </tr>
                      }
                    </table>
                  </mat-expansion-panel>
                }
              }
            </mat-accordion>
            @if (productListValue.radar.length > 0) {
              <!--Radar Product Accordion-->
              <div mat-subheader>
                <fa-icon [icon]="['far', 'umbrella']" size="lg"></fa-icon>
                &nbsp; {{ 'PRODUCT.RADAR.TITLE' | translate }}
              </div>
            }
            <mat-accordion
              #accordionRadarApp="matAccordion"
              multi
              class="accordion-headers-align">
              @if (productListValue.radar.length > 0) {
                <mat-expansion-panel
                  (expandedChange)="onExpandedChanged('app')">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      @if (
                        'app'
                          | hasUserProductType
                            : 'radar'
                            : productListValue
                            : areAllProductsSelectedValue
                            : userServiceUserDataValue
                      ) {
                        <span>
                          <fa-icon
                            [icon]="['far', 'check']"
                            style="color: green"></fa-icon>
                        </span>
                      } @else {
                        <span>
                          <fa-icon
                            [icon]="['far', 'times']"
                            style="color: red"></fa-icon>
                        </span>
                      }
                      &nbsp;{{ 'PRODUCT.RADAR.TITLE' | translate }}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{
                        'app'
                          | countUserProducts
                            : 'radar'
                            : productListValue
                            : areAllProductsSelectedValue
                            : userServiceUserDataValue
                      }}
                      /
                      {{ productListValue.radar.length }}
                      {{ 'PRODUCT.USERADMIN.PRODUCTS.TITLE' | translate }}
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <table class="product-detail-table" width="100%">
                    <tr>
                      <th align="center">
                        {{ 'PRODUCT.USERADMIN.USERHASACCESS' | translate }}
                      </th>
                      <th>{{ 'PRODUCT.USERADMIN.RADARREGION' | translate }}</th>
                      <th>{{ 'PRODUCT.USERADMIN.RADARZOOM' | translate }}</th>
                      <th>{{ 'PRODUCT.USERADMIN.NOWACTIVE' | translate }}</th>
                      <th>{{ 'PRODUCT.USERADMIN.SEASON' | translate }}</th>
                    </tr>
                    @for (
                      product of productListValue.radar;
                      track $index;
                      let i = $index
                    ) {
                      <tr>
                        <td align="center">
                          <mat-checkbox
                            [checked]="
                              'app'
                                | hasUserProduct
                                  : areAllProductsSelectedValue
                                  : userServiceUserDataValue
                                  : product['id']
                            "
                            (change)="
                              onUserProductChange({
                                event: $event,
                                product,
                                section: 'app',
                              })
                            "></mat-checkbox>
                        </td>
                        <td>
                          {{
                            'PRODUCT.RADAR.REGIONS.' + product['region']
                              | translate
                          }}
                        </td>
                        <td>
                          @for (
                            point of product['productData']['points'];
                            track $index
                          ) {
                            <span> {{ point['searchName'] }}<br /> </span>
                          }
                        </td>
                        <td>
                          @if (product['outOfSeason']) {
                            <fa-icon
                              [icon]="['far', 'times']"
                              style="color: red"></fa-icon>
                          } @else {
                            <fa-icon
                              [icon]="['far', 'check']"
                              style="color: green"></fa-icon>
                          }
                        </td>
                        <td>
                          {{ product['productData']['saison']['start']['day'] }}
                          .{{
                            product['productData']['saison']['start']['month']
                          }}. -
                          {{ product['productData']['saison']['end']['day'] }}
                          .{{
                            product['productData']['saison']['end']['month']
                          }}.
                        </td>
                      </tr>
                    }
                  </table>
                </mat-expansion-panel>
              }
            </mat-accordion>
          </mat-list>
        }
      </mat-card>
    }
  }
  <div class="button-row">
    <button
      mat-raised-button
      class="btn-app-cancel"
      type="button"
      (click)="onCancel()">
      {{ 'PRODUCT.USERADMIN.CANCEL' | translate }}
    </button>
    &nbsp;
    <button mat-raised-button class="btn-app-back" matStepperPrevious>
      {{ 'PRODUCT.USERADMIN.BACK' | translate }}
    </button>
    &nbsp;
    <button mat-raised-button class="btn-app-next" matStepperNext>
      {{ 'PRODUCT.USERADMIN.NEXT' | translate }}
    </button>
    &nbsp;
    @if (!newUser()) {
      <button
        [disabled]="isSaving() || userService.loadingUserList()"
        mat-raised-button
        class="btn-app-save"
        (click)="onSummarizeUser()">
        {{ 'PRODUCT.USERADMIN.SAVE' | translate }}
      </button>
    }
  </div>
</form>
